var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isBtn)?_c('div',{staticClass:"app-back",on:{"click":_vm.goBack}},[_c('img',{attrs:{"src":require("./assets/appback.png"),"alt":""}})]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }